import { shippedLocales } from '@/langs/locales';

export { shippedLocales };

export function resolveLocale(requestedLocale, tenantLocales) {
  const enabledShippedLocales = (tenantLocales ?? []).filter((locale) =>
    shippedLocales.includes(locale),
  );

  if (shippedLocales.includes(requestedLocale) && enabledShippedLocales.includes(requestedLocale)) {
    return requestedLocale;
  }

  if (enabledShippedLocales.includes('en')) return 'en';
  return enabledShippedLocales[0] ?? 'en';
}

export function numberFormatLocale(locale) {
  switch (locale) {
    case 'en':
      return 'en-US';
    case 'uk':
      return 'ua-UA';
    case 'pl':
      return 'pl-PL';
    case 'uz':
      return 'uz-UZ';
    case 'hi':
      return 'hi-IN';
    default:
      return 'en-US';
  }
}
